module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stateName != 'login' && _vm.stateName != 'resetpassword' && _vm.stateName != 'signup' && _vm.stateName != 'signupconfirm') ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top_nav"
  }, [_c('div', {
    staticClass: "nav_menu"
  }, [_c('nav', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/hydroware_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header_module_title",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [(_vm.stateName == 'safetyplanmanagement' || _vm.stateName == 'Compliance Management' || _vm.stateName == 'MAHC Details' || _vm.stateName == 'compliancedoc' || _vm.stateName == 'checklistlanding') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/compliance_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'riskmanagement' || _vm.stateName == 'control plan') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/risk_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'addpersonnel') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/personnel_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'dashboard') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/dashboard_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'suppliers' || _vm.stateName == 'OrganizationDetails') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/admin_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'memberships' || _vm.stateName == 'activitylist') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/patrons_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'chemicalrecord' || _vm.stateName == 'inventory' || _vm.stateName == 'training') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/safety_small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stateName == 'locationpools' || _vm.stateName == 'positions' || _vm.stateName == 'certificates' || _vm.stateName == 'chemicalsettings') ? _c('img', {
    staticClass: "heading_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/settings_small.png")
    }
  }) : _vm._e(), _vm._v(" "), _vm._v(" \n             " + _vm._s(_vm.headingFullText) + " - " + _vm._s(_vm.dLocation) + " - " + _vm._s(_vm.dPoolName) + " \n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {}, [_c('a', {
    staticClass: "user-profile dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [(_vm.currentUser == 'admin@hydro-ware.com') ? _c('img', {
    attrs: {
      "src": require("../../assets/images/honeycomb/admin_small.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentUser != 'admin@hydro-ware.com'),
      expression: "currentUser != 'admin@hydro-ware.com'"
    }],
    attrs: {
      "src": _vm.imgPath ? _vm.imgPath : 'static/images/Default-avatar.jpg',
      "alt": ""
    }
  }), _c('span', {
    staticClass: "header-user-text",
    staticStyle: {
      "padding-right": "12px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatcase")(_vm.userName)))]), _vm._v(" "), _c('span', {
    staticClass: " fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-usermenu pull-right",
    staticStyle: {
      "width": "inherit"
    }
  }, [(_vm.stateName != 'administrator') ? _c('li', {
    on: {
      "click": _vm.myprofile
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.changepassword
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(3)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ChangePasswordModel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('el-form', {
    ref: "ResetForm",
    attrs: {
      "model": _vm.ResetForm,
      "spellcheck": "false",
      "autocomplete": "false"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current Password",
      "prop": "OldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "id": "passwordCurrent"
    },
    model: {
      value: (_vm.ResetForm.OldPassword),
      callback: function($$v) {
        _vm.$set(_vm.ResetForm, "OldPassword", $$v)
      },
      expression: "ResetForm.OldPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-input__icon el-icon fa fa-eye",
    staticStyle: {
      "top": "24px",
      "cursor": "pointer",
      "z-index": "4"
    },
    on: {
      "click": _vm.toggleCurrentPassword
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "passerrornone",
    attrs: {
      "label": "New Password",
      "prop": "NewPassword"
    }
  }, [_c('span', {
    staticClass: "el-input__icon el-icon fa fa-eye",
    staticStyle: {
      "top": "24px",
      "cursor": "pointer",
      "z-index": "4"
    },
    on: {
      "click": _vm.togglePassword
    }
  }), _vm._v(" "), _c('PasswordValidator', {
    attrs: {
      "id": "password"
    },
    model: {
      value: (_vm.ResetForm.NewPassword),
      callback: function($$v) {
        _vm.$set(_vm.ResetForm, "NewPassword", $$v)
      },
      expression: "ResetForm.NewPassword"
    }
  })], 1), _vm._v(" "), (_vm.Ispasswordok && _vm.ResetForm.NewPassword && _vm.ResetForm.NewPassword.length < 40) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                  * Invalid password constrains\n                ")]) : _vm._e(), _vm._v(" "), (_vm.ResetForm.NewPassword.length > 40) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                  * Length should be 8 to 40\n                ")]) : _vm._e(), _vm._v(" "), (_vm.ResetForm.NewPassword && _vm.ResetForm.OldPassword && _vm.ResetForm.NewPassword == _vm.ResetForm.OldPassword) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                  *The old and new passwords are too similar\n                ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    class: {
      'el-form-item': _vm.ResetForm.NewPassword == _vm.ResetForm.ConfirmPassword && _vm.ResetForm.ConfirmPassword, 'passerrornone': _vm.ResetForm.NewPassword != _vm.ResetForm.ConfirmPassword && _vm.ResetForm.ConfirmPassword
    },
    attrs: {
      "label": "Confirm Password",
      "prop": "ConfirmPassword"
    }
  }, [_c('span', {
    staticClass: "el-input__icon el-icon fa fa-eye",
    staticStyle: {
      "top": "24px",
      "cursor": "pointer",
      "z-index": "4"
    },
    on: {
      "click": _vm.togglePasswordConfirm
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "passwordconfirm",
      "type": "password"
    },
    nativeOn: {
      "keydown": function($event) {
        $event.keyCode === 32 ? $event.preventDefault() : true
      }
    },
    model: {
      value: (_vm.ResetForm.ConfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.ResetForm, "ConfirmPassword", $$v)
      },
      expression: "ResetForm.ConfirmPassword"
    }
  })], 1), _vm._v(" "), (_vm.ResetForm.NewPassword != _vm.ResetForm.ConfirmPassword && _vm.ResetForm.ConfirmPassword) ? _c('div', {
    staticStyle: {
      "color": "#ff5245",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                  * Passwords don't match\n                ")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "color": "gray",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white",
      "width": "125px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.ResetForm.OldPassword || _vm.isdisablebutton || _vm.ResetForm.NewPassword.length > 40 || _vm.ResetForm.NewPassword == _vm.ResetForm.OldPassword
    },
    on: {
      "click": function($event) {
        return _vm.submitchangePassword(_vm.ResetForm)
      }
    }
  }, [_vm._v("Submit\n              ")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "emailAlert",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Alerts")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  })]), _vm._v(" "), _vm._v("\n              --Alerts are a future enhancement--\n              ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', {
    staticStyle: {
      "font-size": "1.2em",
      "padding-left": "7px"
    }
  }, [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "1.2em",
      "padding-left": "3px"
    }
  }, [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-sign-out t"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "1.2em",
      "padding-left": "3px"
    }
  }, [_vm._v("Log Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Change Password")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c62a07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 783
// module chunks = 1